import React from 'react';
import { useTranslation } from 'react-i18next';
import { Route, Redirect } from 'react-router-dom';
import { styles } from 'yankees-react-utils';
import Overview from './Overview/Overview';
import PitchBreakdown from './PitchBreakdown/PitchBreakdown';
import PitchComparison from './PitchComparison';
import RouterTabs from '../../../components/RouterTabs';
import PitchingMonitor from './PitchingMonitor';
import BatTracking from './BatTracking';

const PitcherStrengths = ({ match: { path, url } }) => {
    const { t: translate } = useTranslation();

    const tabs = [...(window.$IsDugoutApp ? [] : [{
        key: 'overview',
        path: `${url}/overview`,
        title: translate('sections.reports.pitcher.overview-title'),
        component: () => <Overview />,
    }]), {
        key: 'pitchbreakdown',
        path: `${url}/pitchbreakdown`,
        title: translate('sections.reports.pitcher.pitchbreakdown-title'),
        component: () => <PitchBreakdown />,
    }, ...(window.$IsDugoutApp ? [] : [{
        key: 'pitchcomparison',
        path: `${url}/pitchcomparison`,
        title: translate('sections.reports.pitcher.pitchcomparison-title'),
        component: () => <PitchComparison />,
    }, {
        key: 'pitching-monitor',
        path: `${url}/pitching-monitor`,
        title: translate('sections.reports.pitcher.pitching-monitor-title'),
        component: () => <PitchingMonitor />,
    }, {
        key: 'bat-tracking',
        path: `${url}/bat-tracking`,
        title: translate('sections.reports.pitcher.bat-tracking-title'),
        component: () => <BatTracking />,
    }])];

    return (
        <>
            <Route path={path} exact render={() => <Redirect to={{ pathname: tabs[0].path }} />} />
            <h2 className="mt-1">{translate('sections.reports.pitcher.pitcher-strengths')}</h2>
            <RouterTabs tabs={tabs} activeColor={styles.theme.background.gallery} />
        </>
    );
};

export default PitcherStrengths;
